'use strict';

angular.module('app.profileInfluencer', ['ui.router', 'angular-img-cropper', 'sotos.crop-image'])

.config(['$stateProvider', '$urlRouterProvider', function($stateProvider) {
        $stateProvider.state('home.profileInfluencer', {
                requireLogin: true,
                url: 'profileInfluencer',
                templateUrl: 'app/profile/partials/profile-influencer.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['User'],
                    navMarker: ['profileInfluencer', 'settings']
                },
                controller: 'profileInfluencerCtrl'
            })
}])

.controller('profileInfluencerCtrl', function ($scope, $rootScope, localStorageService, $http, $upload) {
        var definitions = angular.copy($rootScope.definitions);
        $scope.networkList = definitions.network;
        $scope.countryList = definitions.countries;
        $scope.influencerId = "";
        $scope.croppedImage = null;
        $scope.croppedImageOptions = {}; 
        $scope.croppedImageOptions.image= null;
        $scope.croppedImageOptions.viewSizeWidth= 150;
        $scope.croppedImageOptions.viewSizeHeight= 150;
        $scope.croppedImageOptions.viewShowRotateBtn= true;
        $scope.croppedImageOptions.rotateRadiansLock= true;
        $scope.croppedImageOptions.outputImageWidth= 20 ;
        $scope.croppedImageOptions.outputImageHeight= 20;
        $scope.croppedImageOptions.outputImageRatioFixed= false;
        $scope.croppedImageOptions.outputImageType= "jpeg";
        $scope.croppedImageOptions.outputImageSelfSizeCrop= true;
        $scope.croppedImageOptions.viewShowCropTool= true;

        $scope.profile = $rootScope.currentUser;
        $scope.profile.influencerInformation = $rootScope.influencerInformation;

        var url = $rootScope.apiUrl + 'admin/getLanguagesOfInterestingCountries';
        $http.get(url, {loader: false})
            .success(function(response){
                $scope.languageList = response.data;
                $scope.languageList.forEach(function (val) {
                    $scope.profile.influencerInformation.influencerLanguages.forEach(function (item) {
                        if (item.language != null) {
                            if (val.id == item.language.id) {
                                val.ticked = true;
                            }
                        }
                    }) 
                })
        })
        $scope.countryList.forEach(function(item) {
            if ($scope.profile.influencerInformation.country != null) {
                if (item.id == $scope.profile.influencerInformation.country.id) {
                    item.ticked = true;
                }
            }
        })    
        $scope.networkList.forEach(function(item) {
            if ($scope.profile.influencerInformation.network != null) {
                if (item.id == $scope.profile.influencerInformation.network.id) {
                    item.ticked = true;
                }
            }
        }) 
        $scope.influencerId = $scope.profile.influencerInformation.id;     

        var dataURItoBlob = function(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = decodeURI(dataURI.split(',')[1]);
            }
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var array = [];
            for(var i = 0; i < byteString.length; i++) {
                array.push(byteString.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {type: mimeString});
        };

        $scope.uploadCroppedImage = function(){

            var blob = dataURItoBlob($scope.croppedImage);
            var fd = new FormData();
            fd.append("picture", blob);

            var  req = {
                url: $rootScope.apiUrl + 'upload',
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: fd
            }

            $http(req)
                .success(function(response){
                    $scope.croppedImage = response.image;
                    $scope.save();
                })
                .error(function(response){

                    })

        }   
        
        $scope.save = function(){

            $scope.selectedNetwork = "";
            $scope.networkList.forEach(function (val) {
                if (val.ticked === true)
                {
                     $scope.selectedNetwork = val.id;
                }     
            });

            $scope.selectedCountry = "";
            $scope.countryList.forEach(function (val) {
                if (val.ticked === true)
                {
                     $scope.selectedCountry = val.id;
                }     
            });

            $scope.selectedLanguage = [];
            $scope.languageList.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedLanguage.push(val.id)
            });

            var data = {
                firstName: $scope.profile.firstName,
                lastName: $scope.profile.lastName,
                email: $scope.profile.email,
                phone: $scope.profile.phone,
                image: $scope.croppedImage
            }        
              
            var req = {
                url: $rootScope.apiUrl + 'user/updateprofile',
                method: 'POST',
                data: JSON.stringify(data)
            }

            $http(req).success(function(response){
                $rootScope.currentUser.image = $scope.croppedImage ? $scope.croppedImage : $rootScope.currentUser.image;
                localStorageService.set('currentUser', $rootScope.currentUser);  
                
                $scope.errorMessage = false;
                $scope.croppedImageOptions.image = null;

            })
            .error(function(data){
                $scope.errorMessage = data.message;
            });

            data = {
                domain: $scope.profile.influencerInformation.domain,
                name: $scope.profile.influencerInformation.name,
                isActive: $scope.profile.influencerInformation.isActive,
                network: $scope.selectedNetwork,
                country: $scope.selectedCountry,
                languages: $scope.selectedLanguage
            }

            var req = {
                url: $rootScope.apiUrl + 'admin/updateInfluencer/' + $scope.influencerId,
                method: 'POST',
                data: JSON.stringify(data)
            }

            $http(req).success(function(response){

            })
            .error(function(data){
                $scope.errorMessage = data.message;
            });
        }

        $scope.updateProfile = function(){
            if($scope.croppedImageOptions.image != null){
                $scope.$broadcast('cropImageSave');
            }else{
                $scope.save();    
            }
            
        }
    }
)